/**
 * CommentGetRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { CommentData } from './comment_data'

/**
 * CommentGetRes
 */
export interface CommentGetRes {
  /** 评论详情 */
  items?: CommentData[]
}

/**
 * CommentGetRes Schema
 */
export const CommentGetResSchema: SchemaDefinition = {
  properties: {
    items: {
      description: '评论详情',
      format: '[]*model.CommentData',
      items: { $ref: 'CommentData', description: '' },
      type: 'array',
      label: '评论详情',
    },
  },
  type: 'object',
}
